import "./lib/Sentry.js";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/Routes.jsx";
import "./index.css";
import "@fortawesome/fontawesome-pro/js/regular.min.js";
import "@fortawesome/fontawesome-pro/js/fontawesome.min.js";

const App = () => {
  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
};

// create react root with react 18.2
ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
